import { EMAIL_REGEX } from '@/common/utils';

function validateEmail(email) {
  return EMAIL_REGEX.test(email);
}

export { validateEmail };

